import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { AuthenticationError } from '../../../../api/requests/tuitionProcess';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getFormData } from '../api';
import { FormDataResponseType } from '../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  FormDataResponseType,
  AuthenticationError | AxiosResultDefaultError
>();

export function useSurveyResultFiltersLoader() {
  return useFetch();
}

export const SurveyResultFiltersLoaderConsumer = FetchConsumer;

export default function SurveyResultFiltersLoader({
  children,
}: BaseLoaderProps) {
  const request = useCallback(async () => {
    return getFormData();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
